import EmptyRoundedRectangleIcon from '@assets/icons/empty-rounded-rectangle.svg';
import i18n from '@/utils/i18n';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { Text, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

export const AlertFeedEmpty: React.FC = () => {
  const [styles, theme] = useStyles();
  const { isSmallLayout } = useLayoutContext();
  return (
    <View style={[styles.container, isSmallLayout ? styles.card : null]}>
      <EmptyRoundedRectangleIcon stroke={theme.sk.color.icon.primary} />
      <View style={styles.textBox}>
        <Text style={[FONTS.primary, TYPOGRAPHY.h3, styles.header]}>
          {i18n.t('insights_hub.empty_feed_header')}
        </Text>
        <Text style={[FONTS.primary, TYPOGRAPHY.description, styles.subtitle]}>
          {i18n.t('insights_hub.empty_feed_subtitle')}
        </Text>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  card: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderRadius: 8,
    paddingHorizontal: 8,
  },
  container: {
    alignItems: 'center',
    paddingVertical: 168,
  },
  header: {
    color: theme.sk.color.text.primary,
    textAlign: 'center',
  },
  subtitle: {
    color: theme.sk.color.text.secondary,
    fontSize: 16,
    marginTop: 8,
    textAlign: 'center',
  },
  textBox: {
    alignItems: 'center',
    marginTop: 20,
    paddingHorizontal: 32,
  },
}));
